module.exports = __webpack_public_path__ + "img/download-3-panel-2-INT.c40bad1b.png";